/**
 * Nav Finder Drawer — Slide-out "Find Your Color" drawer triggered from navigation.
 *
 * Intercepts clicks on "Enter License Plate", "Search by Vehicle", and
 * "Search by Color Name or Code" links inside mega menus (or regular dropdowns),
 * then opens a glass-effect drawer with the corresponding search tool.
 */
(function () {
  'use strict';
  if (window.__NavFinderInitialized) return;
  window.__NavFinderInitialized = true;
  /* v4 — brand interception + fuzzy matching */

  /* ── Constants ───────────────────────────────────────────────── */
  var LUNA_API = 'https://luna-paint-api-298547824318.us-central1.run.app';

  // Canonical MCC API (replaces the old Luna taxonomy API for dropdowns)
  var MCC_API_BASE = 'https://search.mycarcolor.com';
  // Public search key (same key the embedded iframe uses: NEXT_PUBLIC_MCC_API_KEY).
  // TODO(owner): replace placeholder with the real public key (or wire to a theme setting).
  var MCC_API_KEY = 'ak_prod_2238b20a02f961eebab4:sk_prod_430b08037b57376be';
  var MCC_HEADERS = { 'Authorization': 'Bearer ' + MCC_API_KEY, 'accept': 'application/json' };
  var DECODE_API = 'https://dyc-ai-search.vercel.app/api/vehicle-decode';

  var US_STATES = [
    {c:'AL',n:'Alabama'},{c:'AK',n:'Alaska'},{c:'AZ',n:'Arizona'},
    {c:'AR',n:'Arkansas'},{c:'CA',n:'California'},{c:'CO',n:'Colorado'},
    {c:'CT',n:'Connecticut'},{c:'DE',n:'Delaware'},{c:'FL',n:'Florida'},
    {c:'GA',n:'Georgia'},{c:'HI',n:'Hawaii'},{c:'ID',n:'Idaho'},
    {c:'IL',n:'Illinois'},{c:'IN',n:'Indiana'},{c:'IA',n:'Iowa'},
    {c:'KS',n:'Kansas'},{c:'KY',n:'Kentucky'},{c:'LA',n:'Louisiana'},
    {c:'ME',n:'Maine'},{c:'MD',n:'Maryland'},{c:'MA',n:'Massachusetts'},
    {c:'MI',n:'Michigan'},{c:'MN',n:'Minnesota'},{c:'MS',n:'Mississippi'},
    {c:'MO',n:'Missouri'},{c:'MT',n:'Montana'},{c:'NE',n:'Nebraska'},
    {c:'NV',n:'Nevada'},{c:'NH',n:'New Hampshire'},{c:'NJ',n:'New Jersey'},
    {c:'NM',n:'New Mexico'},{c:'NY',n:'New York'},{c:'NC',n:'North Carolina'},
    {c:'ND',n:'North Dakota'},{c:'OH',n:'Ohio'},{c:'OK',n:'Oklahoma'},
    {c:'OR',n:'Oregon'},{c:'PA',n:'Pennsylvania'},{c:'RI',n:'Rhode Island'},
    {c:'SC',n:'South Carolina'},{c:'SD',n:'South Dakota'},{c:'TN',n:'Tennessee'},
    {c:'TX',n:'Texas'},{c:'UT',n:'Utah'},{c:'VT',n:'Vermont'},
    {c:'VA',n:'Virginia'},{c:'WA',n:'Washington'},{c:'WV',n:'West Virginia'},
    {c:'WI',n:'Wisconsin'},{c:'WY',n:'Wyoming'},{c:'DC',n:'District of Columbia'}
  ];

  var cache = { brands: null, models: {}, years: {} };

  /* ── OEM brand detection for mega menu interception ──────────── */
  var OEM_REGEX = /\/collections\/([a-z0-9-]+?)-oem(?:$|[/-])/;
  /* Values must match Luna API brand names (case-insensitive) */
  var SLUG_TO_BRAND = {
    'acura':'Acura','alfa-romeo':'Alfa Romeo','aston-martin':'Aston Martin',
    'audi-vw':'Audi','bentley':'Bentley','bmw':'BMW','buick':'Buick',
    'cadillac':'Cadillac','chevrolet':'Chevrolet','chrysler':'Chrysler',
    'datsun':'Datsun','dodge':'Dodge','ferrari':'Ferrari','fiat':'Fiat',
    'fisker':'Fisker','ford':'Ford','honda':'Honda','hummer':'Hummer',
    'hyundai':'Hyundai','infiniti':'Infiniti','jaguar-land-rover':'Landrover',
    'jaguar-2':'Landrover','jeep':'Jeep','kia':'Kia','lamborghini':'Lamborghini',
    'lexus':'Lexus','lincoln':'Lincoln','lotus':'Lotus','lucid':'Lucid',
    'maserati':'Maserati','mazda':'Mazda','mercedes':'Mercedes','mini':'Mini',
    'mitsubishi':'Mitsubishi','morgan':'Morgan','nissan':'Nissan',
    'oldsmobile':'Oldsmobile','plymouth':'Plymouth','porsche':'Porsche',
    'ral':'RAL','rivian':'Rivian','rolls-royce':'Rolls Royce','scion':'Scion',
    'subaru':'Subaru','tesla':'Tesla Motors','toyota-lexus':'Toyota','tvr':'TVR',
    'volvo':'Volvo','vw':'Volkswagen','general-motors':'Gen. Motors USA'
  };

  var pendingBrand = null;
  var mmyBrandApplier = null;

  function brandFromHref(href) {
    if (!href) return null;
    /* Strip query params & hash before matching */
    var clean = href.split('?')[0].split('#')[0];
    var m = clean.match(OEM_REGEX);
    if (!m) return null;
    var slug = m[1];
    /* Exclude non-brand OEM pages */
    if (slug === 'all' || slug === 'popular' || slug === 'luna') return null;
    if (SLUG_TO_BRAND[slug]) return SLUG_TO_BRAND[slug];
    return slug.split('-').map(function (w) {
      return w.charAt(0).toUpperCase() + w.slice(1);
    }).join(' ');
  }

  /* ── Read config from script tag data attributes ────────────── */
  var scriptTag = document.querySelector('script[data-nav-finder-config]');
  var CONFIG = {
    defaultTab: (scriptTag && scriptTag.dataset.defaultTab) || 'mmy',
    showPlate: scriptTag ? scriptTag.dataset.showPlate !== 'false' : true,
    showMmy: scriptTag ? scriptTag.dataset.showMmy !== 'false' : true,
    showColor: scriptTag ? scriptTag.dataset.showColor !== 'false' : true,
    showAI: scriptTag ? scriptTag.dataset.showAi !== 'false' : true,
    title: (scriptTag && scriptTag.dataset.title) || 'Find Your Color'
  };

  /* ── SVG Icons ──────────────────────────────────────────────── */
  var ICON = {
    close: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="18" y1="6" x2="6" y2="18"/><line x1="6" y1="6" x2="18" y2="18"/></svg>',
    search: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>',
    plate: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="6" width="20" height="12" rx="2"/><line x1="6" y1="12" x2="6.01" y2="12"/><line x1="18" y1="12" x2="18.01" y2="12"/></svg>',
    car: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M7 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M17 17m-2 0a2 2 0 1 0 4 0a2 2 0 1 0 -4 0"/><path d="M5 17H3v-6l2-5h9l4 5h1a2 2 0 0 1 2 2v4h-2m-4 0H9m-6-6h15m-6 0V6"/></svg>',
    palette: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="13.5" cy="6.5" r=".5" fill="currentColor"/><circle cx="17" cy="10" r=".5" fill="currentColor"/><circle cx="8.5" cy="8" r=".5" fill="currentColor"/><circle cx="6.5" cy="12" r=".5" fill="currentColor"/><path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.926 0 1.648-.746 1.648-1.688 0-.437-.18-.835-.437-1.125-.29-.289-.438-.652-.438-1.125a1.64 1.64 0 0 1 1.668-1.668h1.996c3.051 0 5.555-2.503 5.555-5.554C21.965 6.012 17.461 2 12 2z"/></svg>',
    alertCircle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="10"/><line x1="12" y1="8" x2="12" y2="12"/><line x1="12" y1="16" x2="12.01" y2="16"/></svg>',
    loader: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="nf-loader-spin"><path d="M12 2v4m0 12v4m-7.07-3.93l2.83-2.83m8.48-8.48l2.83-2.83M2 12h4m12 0h4m-3.93 7.07l-2.83-2.83M7.76 7.76L4.93 4.93"/></svg>',
    arrowRight: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><line x1="5" y1="12" x2="19" y2="12"/><polyline points="12 5 19 12 12 19"/></svg>',
    sparkle: '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M12 3l1.912 5.813a2 2 0 0 0 1.275 1.275L21 12l-5.813 1.912a2 2 0 0 0-1.275 1.275L12 21l-1.912-5.813a2 2 0 0 0-1.275-1.275L3 12l5.813-1.912a2 2 0 0 0 1.275-1.275L12 3z"/></svg>'
  };

  /* ── Helpers ─────────────────────────────────────────────────── */

  function norm(s) { return (s || '').toLowerCase().replace(/[^a-z]/g, ''); }

  function toolKeyFromText(text) {
    var t = norm(text);
    if (t.indexOf('licenseplate') !== -1 || t.indexOf('enterplate') !== -1) return 'plate';
    if (t.indexOf('searchbyvehicle') !== -1 || t.indexOf('makemodel') !== -1) return 'mmy';
    if (t.indexOf('colorname') !== -1 || t.indexOf('colorcode') !== -1 || t.indexOf('codeorname') !== -1 || t.indexOf('bycode') !== -1) return 'color';
    return null;
  }

  /* ════════════════════════════════════════════════════════════════
   *  DRAWER — build once, reuse
   * ════════════════════════════════════════════════════════════════ */

  var drawerEl = null;
  var overlayEl = null;
  var toolEls = {};     // { plate: el, mmy: el, color: el }
  var tabEls = {};      // { plate: btn, mmy: btn, color: btn }
  var activeTab = null;
  var toolsInitialized = {};
  var drawerOpenedAt = 0;

  /* Snap-point state for mobile bottom-sheet */
  var SNAP_POINTS = [0, 0.5, 1]; // 0 = full, 0.5 = half, 1 = closed
  var currentSnapPoint = 0;

  function ensureDrawer() {
    if (drawerEl) return;

    /* Overlay */
    overlayEl = document.createElement('div');
    overlayEl.className = 'nf-overlay';
    overlayEl.addEventListener('click', function () { closeDrawer('overlay'); });
    document.body.appendChild(overlayEl);

    /* Drawer */
    drawerEl = document.createElement('div');
    drawerEl.className = 'nf-drawer';
    drawerEl.setAttribute('role', 'dialog');
    drawerEl.setAttribute('aria-label', 'Find Your Color');

    /* Header */
    var header = document.createElement('div');
    header.className = 'nf-drawer-header';
    header.innerHTML =
      '<h2 class="nf-drawer-title">' + escapeHtml(CONFIG.title) + '</h2>' +
      '<button type="button" class="nf-drawer-close" aria-label="Close">' + ICON.close + '</button>';
    header.querySelector('.nf-drawer-close').addEventListener('click', function () { closeDrawer('button'); });
    drawerEl.appendChild(header);

    /* Tabs — only build enabled ones */
    var tabs = document.createElement('div');
    tabs.className = 'nf-tabs';

    var tabDefs = [];
    if (CONFIG.showMmy)   tabDefs.push({ key: 'mmy',   icon: ICON.car,   label: 'By Vehicle' });
    if (CONFIG.showColor) tabDefs.push({ key: 'color', icon: ICON.palette, label: 'By Code or Color' });
    if (CONFIG.showPlate) tabDefs.push({ key: 'plate', icon: ICON.plate, label: 'License Plate' });
    if (CONFIG.showAI)    tabDefs.push({ key: 'ai',    icon: ICON.sparkle, label: 'AI' });

    tabDefs.forEach(function (def) {
      var btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'nf-tab';
      btn.dataset.tab = def.key;
      btn.innerHTML = def.icon + ' <span>' + def.label + '</span>';
      btn.addEventListener('click', function () { switchTab(def.key); });
      tabs.appendChild(btn);
      tabEls[def.key] = btn;
    });
    /* Only show tab bar if more than 1 tool */
    if (tabDefs.length > 1) drawerEl.appendChild(tabs);

    /* Body */
    var body = document.createElement('div');
    body.className = 'nf-drawer-body';

    /* Build only enabled tools */
    if (CONFIG.showPlate) {
      toolEls.plate = buildPlateTool();
      body.appendChild(toolEls.plate);
    }
    if (CONFIG.showMmy) {
      toolEls.mmy = buildMMYTool();
      body.appendChild(toolEls.mmy);
    }
    if (CONFIG.showColor) {
      toolEls.color = buildColorTool();
      body.appendChild(toolEls.color);
    }
    if (CONFIG.showAI) {
      toolEls.ai = document.createElement('div');
      toolEls.ai.className = 'nf-tool';
      toolEls.ai.dataset.tool = 'ai';
      body.appendChild(toolEls.ai);
    }

    drawerEl.appendChild(body);
    document.body.appendChild(drawerEl);

    /* ESC key */
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawerEl.classList.contains('is-open')) {
        closeDrawer('escape');
      }
    });

    /* ── Mobile snap-point drawer (matches accessories drawer) ── */
    var dragStartY = 0;
    var dragCurrentY = 0;
    var dragStartTime = 0;
    var isDragging = false;
    var dragDrawerHeight = 0;
    var dragStartOffset = 0;

    function findNearestSnapPoint(currentPercent, velocity) {
      var VT = 0.5; // px/ms velocity threshold
      if (velocity > VT) {
        for (var i = 0; i < SNAP_POINTS.length; i++) {
          if (SNAP_POINTS[i] > currentSnapPoint) return SNAP_POINTS[i];
        }
        return SNAP_POINTS[SNAP_POINTS.length - 1];
      }
      if (velocity < -VT) {
        for (var j = SNAP_POINTS.length - 1; j >= 0; j--) {
          if (SNAP_POINTS[j] < currentSnapPoint) return SNAP_POINTS[j];
        }
        return SNAP_POINTS[0];
      }
      var nearest = SNAP_POINTS[0];
      var nearestDist = Math.abs(currentPercent - nearest);
      for (var k = 1; k < SNAP_POINTS.length; k++) {
        var d = Math.abs(currentPercent - SNAP_POINTS[k]);
        if (d < nearestDist) { nearest = SNAP_POINTS[k]; nearestDist = d; }
      }
      return nearest;
    }

    function animateToSnapPoint(snapPoint) {
      var h = drawerEl.offsetHeight;
      var px = snapPoint * h;

      drawerEl.classList.remove('is-dragging');
      drawerEl.style.transition = 'transform 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
      drawerEl.style.transform = 'translateY(' + px + 'px)';

      overlayEl.style.transition = 'opacity 0.35s cubic-bezier(0.4, 0, 0.2, 1)';
      overlayEl.style.opacity = String(Math.max(0, 1 - snapPoint));

      drawerEl.classList.toggle('is-half', snapPoint === 0.5);
      drawerEl.classList.toggle('is-full', snapPoint === 0);
      currentSnapPoint = snapPoint;

      if (snapPoint === 1) {
        setTimeout(function () {
          drawerEl.style.transition = '';
          drawerEl.style.transform = '';
          overlayEl.style.transition = '';
          overlayEl.style.opacity = '';
          drawerEl.classList.remove('is-open', 'is-half', 'is-full');
          overlayEl.classList.remove('is-open');
          unlockBodyScroll();
          currentSnapPoint = 0;
        }, 350);
      } else {
        setTimeout(function () {
          drawerEl.style.transition = '';
          overlayEl.style.transition = '';
          if (snapPoint === 0) {
            drawerEl.style.transform = '';
            overlayEl.style.opacity = '';
          }
        }, 350);
      }
    }

    /* Touch start: drag handle area (top 100px) */
    drawerEl.addEventListener('touchstart', function (e) {
      var touch = e.touches[0];
      var rect = drawerEl.getBoundingClientRect();
      var offsetY = touch.clientY - rect.top;

      if (offsetY <= 100) {
        dragDrawerHeight = drawerEl.offsetHeight;
        dragStartOffset = currentSnapPoint * dragDrawerHeight;
        dragStartY = touch.clientY;
        dragCurrentY = touch.clientY;
        dragStartTime = Date.now();
        isDragging = true;
        drawerEl.classList.add('is-dragging');
      }
    }, { passive: true });

    drawerEl.addEventListener('touchmove', function (e) {
      if (!isDragging) return;
      var touch = e.touches[0];
      dragCurrentY = touch.clientY;
      var deltaY = dragCurrentY - dragStartY;
      var newOffset = dragStartOffset + deltaY;

      if (newOffset < 0) newOffset = 0;
      if (newOffset > dragDrawerHeight) newOffset = dragDrawerHeight;

      drawerEl.style.transform = 'translateY(' + newOffset + 'px)';
      var pct = dragDrawerHeight > 0 ? newOffset / dragDrawerHeight : 0;
      overlayEl.style.opacity = String(Math.max(0, 1 - pct));
    }, { passive: true });

    drawerEl.addEventListener('touchend', function () {
      if (!isDragging) return;
      isDragging = false;

      var deltaY = dragCurrentY - dragStartY;
      var elapsed = Date.now() - dragStartTime;
      var velocity = elapsed > 0 ? deltaY / elapsed : 0;

      var currentOffset = dragStartOffset + deltaY;
      if (currentOffset < 0) currentOffset = 0;
      if (currentOffset > dragDrawerHeight) currentOffset = dragDrawerHeight;
      var currentPercent = dragDrawerHeight > 0 ? currentOffset / dragDrawerHeight : 0;

      var snap = findNearestSnapPoint(currentPercent, velocity);
      animateToSnapPoint(snap);
    }, { passive: true });

    drawerEl.addEventListener('touchcancel', function () {
      if (!isDragging) return;
      isDragging = false;
      animateToSnapPoint(currentSnapPoint);
    }, { passive: true });

    /* Prevent body scroll on overlay touch */
    overlayEl.addEventListener('touchmove', function (e) {
      e.preventDefault();
    }, { passive: false });
  }

  /* ── Body scroll lock (matches accessories drawer pattern) ─── */
  var savedScrollY = 0;

  function lockBodyScroll() {
    savedScrollY = window.pageYOffset || document.documentElement.scrollTop;
    document.body.style.top = '-' + savedScrollY + 'px';
    document.body.classList.add('nf-drawer-open');
  }

  function unlockBodyScroll() {
    document.body.classList.remove('nf-drawer-open');
    document.body.style.top = '';
    window.scrollTo(0, savedScrollY);
  }

  /* ── Open / Close ───────────────────────────────────────────── */

  function openDrawer(toolKey, brand) {
    ensureDrawer();

    /* Set pending brand if provided */
    if (brand) pendingBrand = brand;

    /* Resolve which tab to show */
    var resolvedTab = toolKey;
    if (!resolvedTab || !toolEls[resolvedTab]) {
      resolvedTab = CONFIG.defaultTab;
    }
    /* If that tab was disabled, pick the first available */
    if (!toolEls[resolvedTab]) {
      var keys = Object.keys(toolEls);
      resolvedTab = keys.length ? keys[0] : null;
    }
    if (!resolvedTab) return;

    switchTab(resolvedTab);

    /* If MMY already initialized, apply pending brand directly.
       Only clear pendingBrand on success — if brands haven't loaded
       yet, keep it so loadBrands() can consume it later. */
    if (pendingBrand && resolvedTab === 'mmy' && toolsInitialized.mmy && mmyBrandApplier) {
      if (mmyBrandApplier(pendingBrand)) {
        pendingBrand = null;
      }
    }

    /* Reset snap state for fresh open */
    currentSnapPoint = 0;
    drawerEl.classList.remove('is-half');
    drawerEl.classList.add('is-full');
    drawerEl.style.transform = '';
    overlayEl.style.opacity = '';

    /* Small delay so the CSS transition plays */
    requestAnimationFrame(function () {
      overlayEl.classList.add('is-open');
      drawerEl.classList.add('is-open');
      lockBodyScroll();
    });

    /* Focus the first input + position tab indicator after transition */
    setTimeout(function () {
      var tool = toolEls[resolvedTab];
      if (tool) {
        var inp = tool.querySelector('input:not([disabled]), select:not([disabled])');
        if (inp) inp.focus();
      }
      updateTabIndicator(resolvedTab);
    }, 380);

    drawerOpenedAt = Date.now();
    trackEvent((resolvedTab) + '_opened', brand ? 'brand_' + brand : 'nav_menu');
  }

  function closeDrawer(method) {
    if (!drawerEl) return;
    var durationMs = drawerOpenedAt ? Date.now() - drawerOpenedAt : 0;
    trackEvent('drawer_closed', [activeTab || '', method || 'unknown', durationMs].join('|'));
    overlayEl.classList.remove('is-open');
    drawerEl.classList.remove('is-open', 'is-half', 'is-full');
    drawerEl.style.transform = '';
    overlayEl.style.opacity = '';
    currentSnapPoint = 0;
    drawerOpenedAt = 0;
    unlockBodyScroll();
  }

  /* Expose for external use */
  window.NavFinderDrawer = {
    open: openDrawer,
    close: closeDrawer,
    openWithBrand: function (name) { openDrawer('mmy', name); },
    /** Clear the "waiting for MCC" flag so closeModal won't re-open the drawer */
    clearWaiting: function () { waitingForMCC = false; }
  };

  /* ── Tab switching ──────────────────────────────────────────── */

  var switchTimer = null;

  function switchTab(key) {
    if (!toolEls[key]) return;
    if (switchTimer) { clearTimeout(switchTimer); switchTimer = null; }

    var prevKey = activeTab;
    if (prevKey && prevKey !== key) {
      trackEvent('tab_switched', prevKey + '>' + key);
    }
    activeTab = key;

    /* Update tab buttons */
    Object.keys(tabEls).forEach(function (k) {
      tabEls[k].classList.toggle('is-active', k === key);
    });

    /* Slide the tab indicator */
    updateTabIndicator(key);

    /* Lazy-init tools on first view */
    if (!toolsInitialized[key]) {
      toolsInitialized[key] = true;
      if (key === 'plate') initPlate(toolEls.plate);
      else if (key === 'mmy') initMMY(toolEls.mmy);
      else if (key === 'color') initColor(toolEls.color);
      else if (key === 'ai' && window.PaintAssistant) window.PaintAssistant.buildPanel(toolEls.ai);
    }

    /* Crossfade: fade out old panel, then fade in new one */
    if (prevKey && prevKey !== key && toolEls[prevKey]) {
      /* Start exit animation on old panel */
      toolEls[prevKey].classList.remove('is-active');
      toolEls[prevKey].classList.add('is-leaving');

      /* After exit completes, show new panel */
      switchTimer = setTimeout(function () {
        toolEls[prevKey].classList.remove('is-leaving');
        toolEls[key].classList.add('is-active');
        switchTimer = null;
      }, 150); /* matches nfToolOut duration */
    } else {
      /* First open or same tab — just show immediately */
      Object.keys(toolEls).forEach(function (k) {
        toolEls[k].classList.remove('is-active', 'is-leaving');
      });
      toolEls[key].classList.add('is-active');
    }
  }

  function updateTabIndicator(key) {
    var btn = tabEls[key];
    if (!btn) return;
    var tabs = btn.parentElement;
    if (!tabs) return;
    var tabsRect = tabs.getBoundingClientRect();
    var btnRect = btn.getBoundingClientRect();
    tabs.style.setProperty('--nf-indicator-left', (btnRect.left - tabsRect.left) + 'px');
    tabs.style.setProperty('--nf-indicator-width', btnRect.width + 'px');
  }

  /* ════════════════════════════════════════════════════════════════
   *  BUILD TOOL PANELS
   * ════════════════════════════════════════════════════════════════ */

  function buildPlateTool() {
    var el = document.createElement('div');
    el.className = 'nf-tool';
    el.dataset.nfTool = 'plate';
    el.innerHTML =
      '<h3 class="nf-tool-title">Enter License Plate</h3>' +
      '<p class="nf-tool-desc">We\'ll decode your plate to find your vehicle\'s exact factory color.</p>' +
      '<div class="nf-form">' +
        '<div class="nf-form--plate-row">' +
          '<div class="nf-field">' +
            '<label class="nf-label">Plate Number</label>' +
            '<input type="text" class="nf-input nf-input--plate" data-nf-plate-input placeholder="ABC 1234" autocomplete="off">' +
          '</div>' +
          '<div class="nf-field">' +
            '<label class="nf-label">State</label>' +
            '<select class="nf-select" data-nf-plate-state><option value="">Select State</option></select>' +
          '</div>' +
        '</div>' +
        '<button type="button" class="nf-btn" data-nf-plate-go disabled>' +
          ICON.search + ' <span>Decode Plate</span>' +
        '</button>' +
      '</div>' +
      '<div class="nf-result" data-nf-result style="display:none;"></div>';

    /* Populate states */
    var sel = el.querySelector('[data-nf-plate-state]');
    US_STATES.forEach(function (s) {
      var o = document.createElement('option');
      o.value = s.c; o.textContent = s.n;
      sel.appendChild(o);
    });

    return el;
  }

  function buildMMYTool() {
    var el = document.createElement('div');
    el.className = 'nf-tool';
    el.dataset.nfTool = 'mmy';
    el.innerHTML =
      '<h3 class="nf-tool-title">Search by Vehicle</h3>' +
      '<p class="nf-tool-desc">Select your make, model, and year to find matching paint colors.</p>' +
      '<div class="nf-form nf-form--mmy">' +
        '<div class="nf-field">' +
          '<label class="nf-label">Make</label>' +
          '<select class="nf-select" data-nf-mmy-make><option value="">Select Make</option></select>' +
        '</div>' +
        '<div class="nf-field">' +
          '<label class="nf-label">Model</label>' +
          '<select class="nf-select" data-nf-mmy-model disabled><option value="">Select Model</option></select>' +
        '</div>' +
        '<div class="nf-field">' +
          '<label class="nf-label">Year</label>' +
          '<select class="nf-select" data-nf-mmy-year disabled><option value="">Select Year</option></select>' +
        '</div>' +
        '<button type="button" class="nf-btn" data-nf-mmy-go disabled>' +
          ICON.search + ' <span>Find Colors</span>' +
        '</button>' +
      '</div>';

    return el;
  }

  function buildColorTool() {
    var el = document.createElement('div');
    el.className = 'nf-tool';
    el.dataset.nfTool = 'color';
    el.innerHTML =
      '<h3 class="nf-tool-title">Search by Color</h3>' +
      '<p class="nf-tool-desc">Enter a color name, code, or description to search our paint database.</p>' +
      '<div class="nf-form">' +
        '<div class="nf-field">' +
          '<label class="nf-label">Color Name or Code</label>' +
          '<input type="text" class="nf-input" data-nf-color-input placeholder="e.g. Obsidian Black or NH731P" autocomplete="off">' +
        '</div>' +
        '<button type="button" class="nf-btn" data-nf-color-go disabled>' +
          ICON.search + ' <span>Search Colors</span>' +
        '</button>' +
      '</div>';

    return el;
  }

  /* ════════════════════════════════════════════════════════════════
   *  TOOL LOGIC
   * ════════════════════════════════════════════════════════════════ */

  /* ── Open MCC ───────────────────────────────────────────────── */

  var waitingForMCC = false;
  var lastActiveTab = null;

  function openMCC(query) {
    /* Remember where we were so we can come back */
    lastActiveTab = activeTab;
    waitingForMCC = true;

    /* Close drawer first so MCC overlay appears cleanly */
    closeDrawer('mcc_fallback');

    if (window.DYCFinderAPI && window.DYCFinderAPI.openMCCText) {
      window.DYCFinderAPI.openMCCText(query);
      return;
    }
    /* Fallback: direct MCC iframe */
    var iframe = document.getElementById('mcc-iframe');
    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.src = 'https://mcc-dyc.vercel.app';
      iframe.allow = 'fullscreen';
      iframe.id = 'mcc-iframe';
      iframe.className = 'mcc-iframe';
      Object.assign(iframe.style, {
        position: 'fixed', top: '0', left: '0', width: '100%',
        height: '100vh', border: 'none', zIndex: '9999', display: 'none'
      });
      document.body.appendChild(iframe);
    }
    iframe.style.display = 'block';
    document.body.classList.add('mcc-drawer-open');
    var msg = { type: 'openModal', window: 'colorSearch', searchQuery: query };
    setTimeout(function () {
      if (iframe.contentWindow) iframe.contentWindow.postMessage(msg, '*');
    }, 200);
  }

  /* ── Listen for MCC close → reopen drawer ─────────────────── */
  window.addEventListener('message', function (event) {
    if (!waitingForMCC) return;
    if (!event.data) return;

    /* If MCC sends addToCart (selectColor with action), clear the flag
       so the subsequent closeModal doesn't re-open the drawer */
    if (event.data.type === 'selectColor' && event.data.action === 'addToCart') {
      waitingForMCC = false;
      return;
    }

    if (event.data.type !== 'closeModal') return;

    waitingForMCC = false;

    /* Re-open drawer on the tab the user was on (inputs are preserved in DOM) */
    setTimeout(function () {
      openDrawer(lastActiveTab || 'color');
    }, 600); /* Wait for MCC iframe fade-out (500ms in mcc.js) */
  });

  /* ── License Plate Tool ─────────────────────────────────────── */

  function initPlate(panel) {
    var input = panel.querySelector('[data-nf-plate-input]');
    var stateEl = panel.querySelector('[data-nf-plate-state]');
    var btn = panel.querySelector('[data-nf-plate-go]');
    var result = panel.querySelector('[data-nf-result]');

    function updateBtn() {
      btn.disabled = !(input.value.trim().length >= 2 && stateEl.value);
    }

    input.addEventListener('input', function () {
      input.value = input.value.toUpperCase();
      updateBtn();
    });
    stateEl.addEventListener('change', updateBtn);

    input.addEventListener('keypress', function (e) {
      if (e.key === 'Enter' && !btn.disabled) { e.preventDefault(); decode(); }
    });
    btn.addEventListener('click', function () { decode(); });

    function showLoading() {
      result.innerHTML =
        '<div class="nf-loading">' +
          '<div class="nf-loading-icon">' + ICON.loader + '</div>' +
          '<div class="nf-loading-text">' +
            '<div class="nf-loading-title">Decoding Plate...</div>' +
            '<div class="nf-loading-subtitle">Looking up ' + escapeHtml(input.value.trim()) + '</div>' +
          '</div>' +
        '</div>';
      result.style.display = 'block';
    }

    function showResult(data) {
      var vehicle = [data.make, data.model, data.year].filter(Boolean).join(' ');
      var brandSlug = (data.make || '').toLowerCase().replace(/[^a-z0-9]/g, '-');

      result.innerHTML =
        '<div class="nf-result-row">' +
          '<div class="nf-result-icon-box">' + ICON.car + '</div>' +
          '<div class="nf-result-card">' +
            '<div class="nf-result-vehicle">' + escapeHtml(vehicle) + '</div>' +
            (data.color ? '<div class="nf-result-factory">Factory: ' + escapeHtml(data.color) + '</div>' : '') +
            '<div class="nf-result-desc">We found matching colors for your vehicle</div>' +
            '<button type="button" class="nf-result-action" data-nf-view-colors>' +
              'View ' + escapeHtml(data.make) + ' Colors ' + ICON.arrowRight +
            '</button>' +
          '</div>' +
        '</div>';
      result.style.display = 'block';

      /* Try brand logo */
      var logoEl = result.querySelector('.nf-result-icon-box');
      var img = new Image();
      img.onload = function () {
        logoEl.classList.add('has-brand-logo');
        logoEl.innerHTML = '<img src="' + img.src + '" alt="' + escapeHtml(data.make) + '" class="nf-brand-logo">';
      };
      img.src = '/cdn/shop/files/brand-logo-' + brandSlug + '.png';

      result.querySelector('[data-nf-view-colors]').addEventListener('click', function () {
        openMCC(vehicle);
      });
    }

    function showError(msg) {
      result.innerHTML =
        '<div class="nf-result-row">' +
          '<div class="nf-result-icon-box nf-result-icon-box--error">' + ICON.alertCircle + '</div>' +
          '<div class="nf-result-card nf-result-card--error">' +
            '<div class="nf-result-vehicle">Vehicle Not Found</div>' +
            '<div class="nf-result-desc">' + escapeHtml(msg || 'Check your plate number and state, then try again.') + '</div>' +
          '</div>' +
        '</div>';
      result.style.display = 'block';
    }

    async function decode() {
      btn.classList.add('is-loading');
      btn.disabled = true;
      showLoading();

      try {
        var data = await fetchDecode(input.value.trim(), stateEl.value);
        if (!data || !data.make) throw new Error('Vehicle not found. Check your plate number and state.');
        showResult(data);
        trackEvent('plate_decode_success', [data.year, data.make, data.model].join(' '));
      } catch (err) {
        showError(err.message);
        trackEvent('plate_decode_error', err.message);
      }

      btn.classList.remove('is-loading');
      updateBtn();
    }
  }

  async function fetchDecode(plate, state) {
    var attempts = 0;
    var data;
    while (attempts < 2) {
      var resp = await fetch(DECODE_API, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ type: 'us_plate', value: plate, state: state })
      });
      var text = await resp.text();
      data = text ? JSON.parse(text) : {};
      if (!resp.ok) throw new Error(data.error || 'Decode request failed');
      if (data.make && data.model) return data;
      if (attempts < 1) await new Promise(function (r) { setTimeout(r, 800); });
      attempts++;
    }
    return data;
  }

  /* ── MMY Tool ───────────────────────────────────────────────── */

  function initMMY(panel) {
    var makeEl = panel.querySelector('[data-nf-mmy-make]');
    var modelEl = panel.querySelector('[data-nf-mmy-model]');
    var yearEl = panel.querySelector('[data-nf-mmy-year]');
    var btn = panel.querySelector('[data-nf-mmy-go]');
    var state = { make: '', brandId: '', model: '', year: '', modelId: '', hasModels: true };

    /* Progressive: searchable as soon as a Make is chosen; model/year refine it.
       Updates the button enabled-state + label ("View all <make> colors"). */
    function updateMmyBtn() {
      btn.disabled = !state.brandId;
      var span = btn.querySelector('span');
      if (!span) return;
      if (state.model && state.year) {
        span.textContent = 'Search ' + state.make + ' ' + state.model + ' ' + state.year;
      } else if (state.model) {
        span.textContent = 'View all ' + state.make + ' ' + state.model + ' colors';
      } else if (state.make) {
        span.textContent = 'View all ' + state.make + ' colors';
      } else {
        span.textContent = 'Find Colors';
      }
    }

    /* Brand pre-select: set Make dropdown + trigger model load */
    function applyBrand(brandName) {
      if (!cache.brands || !cache.brands.length) return false;
      var search = brandName.toLowerCase();
      var match = null;
      /* Pass 1: exact match */
      for (var i = 0; i < cache.brands.length; i++) {
        if (cache.brands[i].value.toLowerCase() === search) {
          match = cache.brands[i]; break;
        }
      }
      /* Pass 2: one starts with the other (handles "Mercedes" vs "Mercedes-Benz" etc.) */
      if (!match) {
        for (var j = 0; j < cache.brands.length; j++) {
          var v = cache.brands[j].value.toLowerCase();
          if (v.indexOf(search) === 0 || search.indexOf(v) === 0) {
            match = cache.brands[j]; break;
          }
        }
      }
      if (!match) {
        console.warn('Nav Finder: brand "' + brandName + '" not found in brands list');
        trackEvent('brand_preselect_miss', brandName);
        return false;
      }
      makeEl.value = match.value;
      makeEl.dispatchEvent(new Event('change'));
      trackEvent('brand_preselect', match.value);
      return true;
    }
    mmyBrandApplier = applyBrand;

    loadBrands();

    makeEl.addEventListener('change', function () {
      var mOpt = makeEl.options[makeEl.selectedIndex];
      state.make = makeEl.value;
      state.brandId = mOpt ? mOpt.dataset.id || '' : '';
      state.model = ''; state.year = ''; state.modelId = '';
      resetSelect(modelEl, 'Select Model');
      resetSelect(yearEl, 'Select Year');
      updateMmyBtn();
      if (state.brandId) loadModels(state.brandId);
    });

    modelEl.addEventListener('change', function () {
      var opt = modelEl.options[modelEl.selectedIndex];
      state.model = modelEl.value;
      state.modelId = opt ? opt.dataset.id || '' : '';
      state.year = '';
      resetSelect(yearEl, 'Select Year');
      updateMmyBtn();
      if (state.brandId && state.modelId) loadYears(state.brandId, state.modelId);
    });

    yearEl.addEventListener('change', function () {
      state.year = yearEl.value;
      updateMmyBtn();
    });

    btn.addEventListener('click', function () {
      // Progressive structured MMY search: as long as we have a brand_id, send whatever
      // is selected (make-only -> all colors; +model -> all years; +year -> that year).
      if (state.brandId &&
          window.DYCFinderAPI && typeof window.DYCFinderAPI.openMCCMMY === 'function') {
        window.DYCFinderAPI.openMCCMMY({
          brandId: state.brandId,
          modelId: state.modelId || undefined,
          year: state.year || undefined,
          make: state.make,
          model: state.model || undefined
        });
        trackEvent('mmy_search', [state.make, state.model, state.year].filter(Boolean).join(' '));
        return;
      }
      // No brand_id / API unavailable: free-text fallback.
      var q = [state.make, state.model, state.year].filter(Boolean).join(' ');
      openMCC(q);
      trackEvent('mmy_search', q);
    });

    async function loadBrands() {
      if (cache.brands) {
        populateSelect(makeEl, cache.brands, 'Select Make');
        if (pendingBrand) { applyBrand(pendingBrand); pendingBrand = null; }
        return;
      }
      try {
        var resp = await fetch(MCC_API_BASE + '/motomix/makes', { headers: MCC_HEADERS });
        var data = await resp.json();
        cache.brands = normList(Array.isArray(data) ? data : (data.makes || []));
        populateSelect(makeEl, cache.brands, 'Select Make');
        if (pendingBrand) { applyBrand(pendingBrand); pendingBrand = null; }
      } catch (e) { console.error('Nav Finder: brands fetch failed', e); }
    }

    async function loadModels(brandId) {
      modelEl.disabled = true;
      if (cache.models[brandId]) {
        populateSelect(modelEl, cache.models[brandId], 'Select Model');
        modelEl.disabled = false;
        if (cache.models[brandId].length === 0) { state.hasModels = false; btn.disabled = false; }
        return;
      }
      try {
        var resp = await fetch(MCC_API_BASE + '/motomix/makes/' + encodeURIComponent(brandId) + '/models', { headers: MCC_HEADERS });
        var data = await resp.json();
        cache.models[brandId] = normListModels(Array.isArray(data) ? data : (data.models || []));
        populateSelect(modelEl, cache.models[brandId], 'Select Model');
        modelEl.disabled = false;
        if (cache.models[brandId].length === 0) {
          state.hasModels = false;
          btn.disabled = false;
        } else {
          state.hasModels = true;
        }
      } catch (e) { console.error('Nav Finder: models fetch failed', e); }
    }

    async function loadYears(brandId, modelId) {
      yearEl.disabled = true;
      var cacheKey = brandId + '/' + modelId;
      if (cache.years[cacheKey]) {
        populateSelect(yearEl, cache.years[cacheKey], 'Select Year');
        yearEl.disabled = false;
        return;
      }
      try {
        var resp = await fetch(MCC_API_BASE + '/motomix/makes/' + encodeURIComponent(brandId) + '/models/' + encodeURIComponent(modelId) + '/years', { headers: MCC_HEADERS });
        // mcc-api returns 404 when a model has no years
        var years = [];
        if (resp.ok) {
          var data = await resp.json();
          years = Array.isArray(data) ? data : (data.years || []);
        } else if (resp.status !== 404) {
          console.warn('Nav Finder: years fetch returned status', resp.status);
        }
        cache.years[cacheKey] = normList(years);
        populateSelect(yearEl, cache.years[cacheKey], 'Select Year');
        yearEl.disabled = false;
      } catch (e) { console.error('Nav Finder: years fetch failed', e); }
    }
  }

  /* ── Color Tool ─────────────────────────────────────────────── */

  function initColor(panel) {
    var input = panel.querySelector('[data-nf-color-input]');
    var btn = panel.querySelector('[data-nf-color-go]');

    input.addEventListener('input', function () {
      btn.disabled = input.value.trim().length < 2;
    });
    input.addEventListener('keypress', function (e) {
      if (e.key === 'Enter' && !btn.disabled) { e.preventDefault(); doSearch(); }
    });
    btn.addEventListener('click', function () { doSearch(); });

    function doSearch() {
      var q = input.value.trim();
      if (!q) return;
      openMCC(q);
      trackEvent('color_search', q);
    }
  }

  /* ════════════════════════════════════════════════════════════════
   *  SHARED HELPERS
   * ════════════════════════════════════════════════════════════════ */

  function resetSelect(el, label) {
    el.innerHTML = '<option value="">' + label + '</option>';
    el.disabled = true;
  }

  function populateSelect(el, items, label) {
    el.innerHTML = '<option value="">' + label + '</option>';
    items.forEach(function (it) {
      var o = document.createElement('option');
      o.value = it.value;
      o.textContent = it.label;
      if (it.id) o.dataset.id = it.id;
      el.appendChild(o);
    });
  }

  // Used for makes ({brand_id, brand_name}) and years (plain number[]).
  function normList(arr) {
    if (!Array.isArray(arr)) return [];
    // Years come back as a number[]; sort newest first before mapping.
    var src = arr.slice();
    if (src.length && (typeof src[0] === 'number' ||
        (typeof src[0] !== 'object' && !isNaN(Number(src[0]))))) {
      src.sort(function (a, b) { return Number(b) - Number(a); });
    }
    return src.map(function (item) {
      if (typeof item !== 'object' || item === null) {
        return { value: item, label: String(item) };
      }
      var v = item.brand_name || item.brand || item.name || item.year || item.type || '';
      return {
        value: v,
        label: v,
        // mcc-api makes use brand_id
        id: (item.brand_id != null ? item.brand_id : (item.id || ''))
      };
    });
  }

  function normListModels(arr) {
    if (!Array.isArray(arr)) return [];
    return arr.map(function (item) {
      if (typeof item === 'string') return { value: item, label: item, id: '' };
      var v = item.model_name || item.type || item.model || item.name || '';
      return {
        value: v,
        label: v,
        // mcc-api models use model_id
        id: (item.model_id != null ? item.model_id : (item.id || ''))
      };
    });
  }

  function escapeHtml(str) {
    var div = document.createElement('div');
    div.textContent = str;
    return div.innerHTML;
  }

  /* ── Analytics ──────────────────────────────────────────────── */

  function trackEvent(action, label) {
    if (window.DYCAnalytics && typeof window.DYCAnalytics.track === 'function') {
      window.DYCAnalytics.track('custom', {
        category: 'nav_finder',
        action: action,
        label: label || '',
        source: 'nav_finder_drawer'
      });
    }
  }

  /* ════════════════════════════════════════════════════════════════
   *  INIT — intercept nav links
   * ════════════════════════════════════════════════════════════════ */

  function init() {
    /* Find all links inside mega menus and regular dropdown menus */
    var links = document.querySelectorAll(
      '.list-menu--mega a.link, ' +
      '.header-submenu a.link, ' +
      '.header-menu-third-level a.link, ' +
      '.header-menu-second-level a.link, ' +
      '.mega-collection-grid a'
    );

    links.forEach(function (link) {
      if (link.dataset.nfBound) return;

      /* Tool text matching (License Plate, By Vehicle, By Color) */
      var key = toolKeyFromText(link.textContent);
      if (key) {
        link.dataset.nfBound = '1';
        link.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          trackEvent('menu_search_click', key);
          var details = link.closest('details');
          if (details) details.removeAttribute('open');
          setTimeout(function () { openDrawer(key); }, 50);
        });
      }
    });
  }

  /* ── Document-level OEM brand interception (capture phase) ──── */
  /* Uses event delegation so it works regardless of DOM structure,
     timing, or other handlers on mega menu elements. Capture phase
     fires before bubble-phase handlers on <drop-menu>, <details>, etc. */
  var brandListenerBound = false;
  function bindBrandInterception() {
    if (brandListenerBound) return;
    brandListenerBound = true;
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href*="-oem"]');
      if (!link) return;
      var brand = brandFromHref(link.getAttribute('href'));
      if (!brand) return;

      e.preventDefault();
      e.stopImmediatePropagation();
      trackEvent('mega_menu_oem_click', brand.value + '|' + link.getAttribute('href'));

      /* Close mega menu / details */
      var details = link.closest('details');
      if (details) details.removeAttribute('open');

      setTimeout(function () { openDrawer('mmy', brand); }, 50);
    }, true); /* true = capture phase */
  }

  /* ── Hash-based drawer triggering ─────────────────────────────── */
  var HASH_TABS = { mmy: 1, color: 1, plate: 1, ai: 1 };

  function parseFinderHash(hash) {
    var h = (hash || '').toLowerCase().replace('#', '');
    h = h.split('&')[0]; /* strip trailing &preview_theme_id=… etc. */
    if (!h.startsWith('finder')) return null;
    var tab = h.split('-')[1] || null;
    return tab && HASH_TABS[tab] ? tab : '';
  }

  function handleHash() {
    var tab = parseFinderHash(location.hash);
    if (tab === null) return;

    var sp = new URLSearchParams(location.search);

    // ?colorcode=WA8555&brand=BMW#finder-color → direct to color detail panel
    // ?cloudid=12345#finder-color → direct by MCC internal ID
    var colorCode = sp.get('colorcode');
    var cloudId = sp.get('cloudid');
    if (colorCode || cloudId) {
      var brand = sp.get('brand') || '';
      openMCCDirectColor({ colorCode: colorCode, brand: brand, cloudId: cloudId });
      trackEvent('url_direct_color', colorCode || cloudId);
    }
    // ?paint=BMW+M4#finder-color → straight to MCC results (skip drawer)
    // Note: can't use ?q= because Shopify intercepts it for built-in search
    else {
      var urlQ = sp.get('paint') || sp.get('color');
      if (tab === 'color' && urlQ) {
        openMCCFromURL(urlQ);
        trackEvent('url_color_search', urlQ);
      } else {
        openDrawer(tab || null);
      }
    }

    if (history.replaceState) {
      history.replaceState(null, '', location.pathname);
    }
  }

  /**
   * URL-triggered MCC: open the MCC iframe directly with a search query.
   * If mcc.js already created #mcc-iframe we reuse it (and let mcc.js
   * handle closeModal). If not (e.g. homepage has no <mcc-search>),
   * we create the iframe ourselves and wire up our own close handler.
   */
  function openMCCFromURL(query) {
    var iframe = document.getElementById('mcc-iframe');
    var selfManaged = !iframe;

    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.src = 'https://mcc-dyc.vercel.app';
      iframe.allow = 'fullscreen';
      iframe.id = 'mcc-iframe';
      iframe.className = 'mcc-iframe';
      Object.assign(iframe.style, {
        position: 'fixed', top: '0', left: '0', width: '100%',
        height: '100vh', border: 'none', zIndex: '9999',
        display: 'none' /* hidden until MCC is ready */
      });
      document.body.appendChild(iframe);
    }
    /* iframe stays display:none — no black flash */

    var msg = { type: 'openModal', window: 'colorSearch', searchQuery: query };
    var sent = false;
    function sendAndReveal() {
      if (sent) return;
      sent = true;
      if (iframe.contentWindow) iframe.contentWindow.postMessage(msg, '*');
      /* Give MCC 400ms to render, then reveal */
      setTimeout(function () {
        iframe.style.display = 'block';
        document.body.classList.add('mcc-drawer-open');
      }, 400);
    }

    /* Wait for iframe to load, then send search query */
    iframe.addEventListener('load', function () {
      setTimeout(sendAndReveal, 500);
    }, { once: true });

    /* Fallback for already-loaded iframe (bfcache / repeat visit) */
    setTimeout(sendAndReveal, 2000);

    /* If we created the iframe ourselves, handle close cleanup */
    if (selfManaged) {
      function onClose(e) {
        if (!e.data || e.data.type !== 'closeModal') return;
        window.removeEventListener('message', onClose);
        document.body.classList.remove('mcc-drawer-open');
        setTimeout(function () { iframe.style.display = 'none'; }, 500);
      }
      window.addEventListener('message', onClose);
    }
  }

  /**
   * URL-triggered direct-to-color: open MCC iframe and send openColor message
   * to skip search results and go straight to a specific color's detail panel.
   * Used for shareable URLs like ?colorcode=WA8555&brand=BMW#finder-color
   */
  function openMCCDirectColor(params) {
    var iframe = document.getElementById('mcc-iframe');
    var selfManaged = !iframe;

    if (!iframe) {
      iframe = document.createElement('iframe');
      iframe.src = 'https://mcc-dyc.vercel.app';
      iframe.allow = 'fullscreen';
      iframe.id = 'mcc-iframe';
      iframe.className = 'mcc-iframe';
      Object.assign(iframe.style, {
        position: 'fixed', top: '0', left: '0', width: '100%',
        height: '100vh', border: 'none', zIndex: '9999',
        display: 'none'
      });
      document.body.appendChild(iframe);
    }

    var msg = { type: 'openColor' };
    if (params.colorCode) msg.colorCode = params.colorCode;
    if (params.brand) msg.brand = params.brand;
    if (params.cloudId) msg.cloudId = params.cloudId;

    var sent = false;
    function sendAndReveal() {
      if (sent) return;
      sent = true;
      if (iframe.contentWindow) iframe.contentWindow.postMessage(msg, '*');
      setTimeout(function () {
        iframe.style.display = 'block';
        document.body.classList.add('mcc-drawer-open');
      }, 400);
    }

    iframe.addEventListener('load', function () {
      setTimeout(sendAndReveal, 500);
    }, { once: true });

    setTimeout(sendAndReveal, 2000);

    if (selfManaged) {
      function onClose(e) {
        if (!e.data || e.data.type !== 'closeModal') return;
        window.removeEventListener('message', onClose);
        document.body.classList.remove('mcc-drawer-open');
        setTimeout(function () { iframe.style.display = 'none'; }, 500);
      }
      window.addEventListener('message', onClose);
    }
  }

  // Intercept clicks on #finder links to prevent scroll-to-element
  document.addEventListener('click', function (e) {
    var link = e.target.closest('a[href*="#finder"]');
    if (!link) return;
    var hash = link.getAttribute('href').split('#')[1];
    if (parseFinderHash(hash) === null) return;
    e.preventDefault();
    location.hash = hash; // triggers hashchange → handleHash
  });

  window.addEventListener('hashchange', handleHash);

  /* ── Boot ────────────────────────────────────────────────────── */
  bindBrandInterception(); /* Capture-phase delegation — safe to bind immediately */
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(); handleHash(); });
  } else {
    init();
    handleHash();
  }
  document.addEventListener('shopify:section:load', function () {
    /* Re-bind links after customizer section reload */
    init();
  });
})();
